





















































import { Component, PropSync, Vue } from 'vue-property-decorator';
import UpdateProfilePersonalityNotificationDialogViewModel
  from '@/vue-app/view-models/components/my-investment-dashboard-v2/update-profile-personality-notification-dialog-view-model';

@Component({ name: 'UpdateProfilePersonalityNotificationDialog' })
export default class UpdateProfilePersonalityNotificationDialog extends Vue {
  @PropSync('isOpen', { type: Boolean, required: true })
  synced_is_open!: boolean;

  @PropSync('yearsWithoutUpdating', { type: Number, required: true })
  synced_years_without_updating!: number;

  distribute_special_contribution_success_view_model = Vue.observable(
    new UpdateProfilePersonalityNotificationDialogViewModel(),
  );

  closeModal() {
    this.synced_is_open = false;
  }
}
